"use client";

import React, { useState, useEffect } from "react";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Legacycraftsmanshiphero() {
  const {
    ref: rootRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/pexels-kateryna-babaieva-1423213-2760241.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/pexels-kateryna-babaieva-1423213-2760241.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/pexels-kateryna-babaieva-1423213-2760241.jpg-wvc-sizes",
    alt: "Industrial piping and mechanical installation excellence"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/pexels-felipe-silva-1458994757-27757293.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/pexels-felipe-silva-1458994757-27757293.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/pexels-felipe-silva-1458994757-27757293.jpg-wvc-sizes",
    alt: "Expert millwright and rigging services in action"
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <section data-section-id="1570" id="legacycraftsmanshiphero" className="relative bg-primary text-foreground overflow-hidden">
      <div ref={rootRef} className="relative mx-auto max-w-[1440px] px-5 sm:px-6 md:px-10 py-24 md:py-32 lg:py-44">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          
          <div className={`order-1 lg:order-2 lg:col-span-5 relative transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: "120ms"
        }}>
            
            <div className="relative">
              
              <div className="relative border-2 border-foreground bg-primary shadow-lg rounded-lg p-4">
                
                <div className="relative overflow-hidden rounded-lg aspect-[4/5]">
                  {slides.map((slide, index) => <div key={index} data-index={index} className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${currentSlide === index ? "opacity-100 z-10" : "opacity-0 z-0"}`}>
                      <img src={slide.src} data-wvc-srcset={slide.srcset} data-wvc-sizes={slide.sizes} alt={slide.alt} loading="lazy" decoding="async" className="block w-full h-full object-cover rounded-lg" />
                    </div>)}

                  <div className="absolute inset-0 z-20 flex items-center justify-between px-2 pointer-events-none">
                    <Button variant="outline" size="icon" onClick={prevSlide} className="pointer-events-auto bg-primary/50 border-white/20 text-white hover:bg-primary/80 rounded-lg" aria-label="Previous slide">
                      <ChevronLeft className="size-5" />
                    </Button>
                    <Button variant="outline" size="icon" onClick={nextSlide} className="pointer-events-auto bg-primary/50 border-white/20 text-white hover:bg-primary/80 rounded-lg" aria-label="Next slide">
                      <ChevronRight className="size-5" />
                    </Button>
                  </div>

                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
                    {slides.map((_, index) => <Button key={index} variant="ghost" size="sm" onClick={() => setCurrentSlide(index)} className={`p-0 min-w-0 h-2 rounded-lg transition-all hover:bg-transparent ${currentSlide === index ? "bg-white w-4" : "bg-white/40 w-2"}`} aria-label={`Go to slide ${index + 1}`} />)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-2 lg:order-1 lg:col-span-7 relative bg-primary p-8 md:p-12 lg:p-16 rounded-lg">
            
            <div className={`flex items-center gap-3 mb-6 md:mb-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            </div>

            <h1 className={`font-default font-extrabold uppercase text-white transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            fontSize: "clamp(2.5rem, 7vw, 6rem)",
            letterSpacing: "-0.02em",
            lineHeight: "0.92",
            transitionDelay: "70ms"
          }}>
              INDUSTRIAL EXCELLENCE, BUILT BY{" "}
              <span className="relative inline-block">
                <span className="relative z-10">EXPERTS</span>
                <span aria-hidden="true" className={`absolute left-0 right-0 bg-primary transition-[width] ease-out`} style={{
                bottom: "-6px",
                height: "4px",
                width: isVisible ? "100%" : "0%",
                transitionDuration: "480ms",
                transitionDelay: "600ms"
              }} />
              </span>{" "}
              DAILY
            </h1>

            <p className={`mt-8 md:mt-10 max-w-xl text-white/90 font-default transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
            lineHeight: "1.6",
            transitionDelay: "210ms"
          }}>
              FABCO Industrial Construction delivers high quality process piping, millwright, rigging and fabrication services. We specialize in simple to complex projects ensuring that every installation meets rigorous safety and performance standards. From initial design to final commissioning, our team provides reliable, timely solutions for your most demanding industrial projects.
            </p>

            <div className={`mt-12 md:mt-14 border-t border-white/20 pt-5 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "360ms"
          }}>
              <dl className="flex flex-wrap items-center gap-y-3">
                <div className="flex items-center gap-2 px-0 sm:px-5">
                  <dt className="font-mono text-[0.6875rem] uppercase text-orange-500" style={{
                  letterSpacing: "0.14em"
                }}>
                    Safety
                  </dt>
                  <dd className="font-mono text-xs sm:text-[0.8125rem] font-semibold uppercase text-white" style={{
                  letterSpacing: "0.08em"
                }}>
                    100% Compliant
                  </dd>
                </div>
                <span aria-hidden="true" className="hidden sm:inline-block h-4 w-px bg-white/20" />
                <div className="flex items-center gap-2 pl-0 sm:pl-5">
                  <dt className="font-mono text-[0.6875rem] uppercase text-orange-500" style={{
                  letterSpacing: "0.14em"
                }}>
                    Status
                  </dt>
                  <dd className="font-mono text-xs sm:text-[0.8125rem] font-semibold uppercase text-white" style={{
                  letterSpacing: "0.08em"
                }}>
                    Operational
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <div aria-hidden="true" className="h-3 w-full bg-gradient-to-r from-primary to-accent" />
    </section>;
}